"use client";

import { c as _c } from "react/compiler-runtime";
import { PROFILE_ACTIVITY_TYPE_TO_TEXT } from "@/entities/IProfile";
import type { ProfileActivityLogType } from "@/types/enums";
import { AnimatePresence, motion, useAnimate } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import ProfileActivityLogsFilterList from "./ProfileActivityLogsFilterList";
export default function ProfileActivityLogsFilter(t0) {
  const $ = _c(36);
  const {
    selected,
    options,
    setSelected
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleOpen = t1;
  let t2;
  if ($[2] !== animateIcon || $[3] !== iconScope || $[4] !== isOpen) {
    t2 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    $[2] = animateIcon;
    $[3] = iconScope;
    $[4] = isOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isOpen) {
    t3 = [isOpen];
    $[6] = isOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  const listRef = useRef(null);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useClickAway(listRef, t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(false);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useKeyPressEvent("Escape", t5);
  const [title, setTitle] = useState("Select");
  let t6;
  if ($[10] !== selected[0] || $[11] !== selected.length) {
    t6 = () => {
      if (selected.length === 0) {
        setTitle("Select");
      } else {
        if (selected.length === 1) {
          setTitle(PROFILE_ACTIVITY_TYPE_TO_TEXT[selected[0]]);
        } else {
          setTitle(`${selected.length} Selected`);
        }
      }
    };
    $[10] = selected[0];
    $[11] = selected.length;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== selected) {
    t7 = [selected];
    $[13] = selected;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== toggleOpen) {
    t8 = e => {
      e.stopPropagation();
      toggleOpen();
    };
    $[15] = toggleOpen;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== title) {
    t9 = <span className="tw-block tw-truncate tw-text-sm tw-font-normal tw-text-iron-400">{title}</span>;
    $[17] = title;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== iconScope) {
    t11 = <span className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3.5"><svg ref={iconScope} className="tw-h-4 tw-w-4 tw-text-iron-200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t10}</svg></span>;
    $[20] = iconScope;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8 || $[24] !== t9) {
    t12 = <button type="button" className="tw-flex tw-w-full tw-items-center tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-px-3.5 tw-py-2.5 tw-font-normal tw-text-iron-50 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 hover:tw-ring-iron-700 focus:tw-bg-iron-950 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 sm:tw-leading-6" onClick={t8}>{t9}{t11}</button>;
    $[22] = t11;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isOpen || $[27] !== options || $[28] !== selected || $[29] !== setSelected) {
    t13 = isOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><ProfileActivityLogsFilterList selected={selected} options={options} setSelected={setSelected} /></motion.div>;
    $[26] = isOpen;
    $[27] = options;
    $[28] = selected;
    $[29] = setSelected;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13) {
    t14 = <AnimatePresence mode="wait" initial={false}>{t13}</AnimatePresence>;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t14) {
    t15 = <div className="tw-flex tw-w-full tw-items-center tw-space-x-4"><div className="tw-w-full"><div ref={listRef} className="tw-w-full"><div className="tw-relative">{t12}{t14}</div></div></div></div>;
    $[33] = t12;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
}